import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { FiscalYearGetter } from '@/store/fiscalYear/fiscalYear.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { RegionGetter } from '@/store/region/region.module';
import { Region } from '@/store/region/region.model';
import RegionFilterComponent from '@/components/regionFilter/RegionFilter.vue';
import ProjectRegionSummaryComponent from '@/components/project/main/projectRegionSummary/ProjectRegionSummary.vue';
import ResultResponseComponent from '@/components/resultResponse/ResultResponse.vue';
import ResultProjectTypeComponent from '@/components/resultProjectType/ResultProjectType.vue';

export default defineComponent({
  name: 'ResultRegionPage',
  components: {
    RegionFilterComponent,
    ProjectRegionSummaryComponent,
    ResultResponseComponent,
    ResultProjectTypeComponent,
  },
  setup: () => {
    const store = useStore();
    const fiscalYear = computed<FiscalYear>(() => store.getters[FiscalYearGetter.BY_ID](fiscalYearId.value));
    const region = computed<Region>(() => store.getters[RegionGetter.BY_ID](regionId.value));
    const fiscalYearId = ref<number | null>();
    const regionId = ref<number | null>();

    const filterChange = (filter: { fiscalYearId: number; regionId: number }) => {
      fiscalYearId.value = filter.fiscalYearId;
      regionId.value = filter.regionId;
    };

    return {
      fiscalYear,
      region,
      filterChange,
    };
  }
});
